import { gql } from '@apollo/client'

export const FETCH_BUNDLES = gql`
  query bundles(
    $first: Int!
    $last: Int!
    $sortDirection: SortDirectionEnum
    $sortColumn: BundlesSortColumnEnum
    $filters: BundleFilters
  ) {
    bundles(
      first: $first
      last: $last
      sortColumn: $sortColumn
      sortDirection: $sortDirection
      filters: $filters
    ) {
      nodes {
        id
        identifier
        commercialName
        startDate
        endDate
        computedStatus
        bundleSchedules {
          status
          audience
          startDate
          endDate
          consumedAt
          freedAt
        }
      }
      totalCount
    }
  }
`
